import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'
import { Dai } from 'components'

const BannerHeadCard = ({
  name,
  showDaiButton = false,
  onDaiClick = () => {},
  isLoading = false,
  hasExistingPolicy = false,
}) => {
  return (
    <Box
      p={2}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography color="primary" variant="h5">
        {name}
      </Typography>
      {showDaiButton && (
        <Dai.StarButton size="small" onClick={onDaiClick} disabled={isLoading}>
          {isLoading
            ? 'GERANDO...'
            : hasExistingPolicy
            ? 'ATUALIZAR COM A DAI'
            : 'GERAR COM A DAI'}
        </Dai.StarButton>
      )}
    </Box>
  )
}

BannerHeadCard.propTypes = {
  name: PropTypes.string.isRequired,
  showDaiButton: PropTypes.bool,
  onDaiClick: PropTypes.func,
  isLoading: PropTypes.bool,
  hasExistingPolicy: PropTypes.bool,
}

export default BannerHeadCard
